exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-card[data-v-659d2391] {\n  height: 100%;\n}\n", ""]);

// exports
